var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#DBFAE6",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0001,
    cy: 25.9999,
    r: 21,
    fill: "#079455",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50008 25.9996C9.50008 16.9212 16.9216 9.49963 26.0001 9.49963C35.0785 9.49963 42.5001 16.9212 42.5001 25.9996C42.5001 35.0781 35.0785 42.4996 26.0001 42.4996C16.9216 42.4996 9.50008 35.0781 9.50008 25.9996ZM26.0001 12.4996C18.5785 12.4996 12.5001 18.5781 12.5001 25.9996C12.5001 33.4212 18.5785 39.4996 26.0001 39.4996C33.4217 39.4996 39.5001 33.4212 39.5001 25.9996C39.5001 18.5781 33.4217 12.4996 26.0001 12.4996ZM33.4367 20.6949C34.0219 21.2812 34.0211 22.231 33.4348 22.8162L24.9298 31.3062C24.3439 31.8911 23.3948 31.8907 22.8094 31.3053L18.5644 27.0603C17.9786 26.4745 17.9786 25.5248 18.5644 24.939C19.1502 24.3532 20.1 24.3532 20.6857 24.939L23.871 28.1243L31.3154 20.693C31.9017 20.1078 32.8514 20.1086 33.4367 20.6949Z",
    fill: "#079455"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.195382dfba6d5f123d244346a81135c0.svg";
export { ForwardRef as ReactComponent };